import { Drawer } from "antd";
import React, { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Button, Col, Row } from "reactstrap";
import FormSelect from "../../form-components/SelectComponent";

interface SettingsFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  Id?: any;
  initialValues: any;
  settingFormData?: any; // New prop for current document data
}

const SettingsForm: React.FC<SettingsFormProps> = ({
  open,
  onClose,
  initialValues,
  onSubmit,
}) => {
  const methods = useForm<any>({});
  const {
    handleSubmit,
    formState: { errors },
    setValue,
  } = methods;
  useEffect(() => {
    if (initialValues) {
      setValue("deliveryLineLevel", initialValues.deliveryLineLevel);
      setValue("approvalToPublish", initialValues.approvalToPublish);
      setValue(
        "questionerForEligibility",
        initialValues.questionerForEligibility
      );
      setValue("approvalForEvaluation", initialValues.approvalForEvaluation);
      setValue("documnetsRequired", initialValues.documnetsRequired);
      setValue("isNegotiable", initialValues.isNegotiable ?? "true");
    }
  }, [open]);
  const submitSettingsData = (values: any) => {
    console.log("values",values);
    onSubmit(values);
    onClose();
  };
  return (
    <Drawer
      title="Tender Settings"
      placement="right"
      onClose={onClose}
      open={open}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitSettingsData)}>
          <Row>Delivery Settings :</Row>
          <Row className="mt-2">
            <Col lg="12">
              <FormSelect
                name="deliveryLineLevel"
                label="Is the Delivery Line Level?"
                options={[
                  { label: "Yes", value: "true" },
                  { label: "No", value: "false" },
                ]}
                required={true}
                placeholder="-Select-"
              />
            </Col>
          </Row>
          <Row className="mt-2">Approval Settings :</Row>
          <Row className="mt-2">
            <Col lg="12">
              <FormSelect
                name="approvalToPublish"
                label="Approval to Publish"
                options={[
                  { label: "Yes", value: "true" },
                  { label: "No", value: "false" },
                ]}
                required={true}
                placeholder="-Select-"
              />
            </Col>
          </Row>
          <Row className="mt-2">Evaluation Settings :</Row>
          <Row className="mt-2">
            <Col lg="12">
              <FormSelect
                name="questionerForEligibility"
                label="Questioner For Eligibility"
                options={[
                  { label: "Yes", value: "true" },
                  { label: "No", value: "false" },
                ]}
                required={true}
                placeholder="-Select-"
              />
            </Col>
            <Col lg="12">
              <FormSelect
                name="approvalForEvaluation"
                label="Approval For Evaluation"
                options={[
                  { label: "Yes", value: "true" },
                  { label: "No", value: "false" },
                ]}
                required={true}
                placeholder="-Select-"
              />
            </Col>
          </Row>
          <Row className="mt-2">Documents Settings :</Row>
          <Row className="mt-2">
            <Col lg="12">
              <FormSelect
                name="documnetsRequired"
                label="Documents From Suppliers / Contractors"
                options={[
                  { label: "Yes", value: "true" },
                  { label: "No", value: "false" },
                ]}
                required={true}
                placeholder="-Select-"
              />
            </Col>
          </Row>
          <Row className="mt-2">Negotiation Settings :</Row>
          <Row className="mt-2">
            <Col lg="12">
              <FormSelect
                name="isNegotiable"
                label="Is Negotiable"
                options={[
                  { label: "Yes", value: "true" },
                  { label: "No", value: "false" },
                ]}
                required={true}
                placeholder="-Select-"
              />
            </Col>
          </Row>
          <Button type="submit" color="primary" className="mt-3">
            Save
          </Button>
        </form>
      </FormProvider>
    </Drawer>
  );
};

export default SettingsForm;
